$(document).ready(function() {
  $('#mh-collection').infiniteScroll({
    // options
    path: '.pagination__next',
    append: '.mh-collection-item',
    history: 'push',
//     hideNav: '.pagination',
    status: '.page-load-status'
  });
  var ms_collection_desc_height_elem = $('.ms-collection-reading');
  var ms_collection_desc_height = ms_collection_desc_height_elem.height();
  ms_collection_desc_height_elem.css('height', '25px');
  
  $('.ms-collection-reading-icon svg').click(function() {
    let tmpContainer = $(this).closest('.ms-collection-reading--container');
    if(tmpContainer.hasClass('ms-show-more')) {
      ms_collection_desc_height_elem.css('height', '25px');
      tmpContainer.removeClass('ms-show-more');
    } else {
      ms_collection_desc_height_elem.css('height', ms_collection_desc_height);
      tmpContainer.addClass('ms-show-more');
    }
  });
});
